<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-form-group :label="$t('name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('district_code')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.district_code) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('city_id')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.city_id) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import DistrictOutlineService from "@/services/DistrictOutlineService";

    export default {
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                form: {
                    city_id: null,
                    district_code: null,
                    name: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                DistrictOutlineService.get(id)
                                      .then((response) => {
                                          this.form = response.data.data;
                                      })
                                      .catch((error) => {
                                          this.showErrors(error)
                                      })
            }
        }
    }
</script>
